/**
 * useDocumentChangeControls — eDMS E2 (change-control ↔ document linkage).
 *
 * GET /api/v1/documents/{id}/change-controls → the change requests that touch
 * this document (number, type, status, dates). Served by the mock-api via the
 * prod-proxy 404-fallback; a production build reads change.change_requests
 * where subject_entity_type='DOCUMENT'.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';

export interface DocumentChangeControl {
  change_request_id: string;
  cr_number: string;
  title: string;
  change_type: string;
  status: string;
  created_at_utc: string;
  effective_at_utc: string | null;
}

export function useDocumentChangeControls(
  documentId: string | undefined,
): UseQueryResult<{ document_id: string; items: DocumentChangeControl[]; count: number }> {
  return useQuery({
    queryKey: ['documents', documentId ?? '', 'change-controls'],
    queryFn: () =>
      apiFetch<{ document_id: string; items: DocumentChangeControl[]; count: number }>(
        `/api/v1/documents/${encodeURIComponent(documentId!)}/change-controls`,
      ),
    enabled: !!documentId,
    staleTime: 30_000,
  });
}
